
import { Component, Vue, Prop } from 'vue-property-decorator';
import { OrdersTableFilters } from '@/store/types';
import SelectComponent from '@/components/shared/Select.vue';

@Component<CateringFilters>({
	components: {
		SelectComponent
	}
})
export default class CateringFilters extends Vue {
	@Prop({ type: Object, required: true }) private tableFilters!: OrdersTableFilters;
	@Prop({ type: String, default: 'kanban' }) private viewType!: string;

	/**
	 * Get type options for filter dropdown.
	 *
	 * @return {{ text: string; value: string }[]}
	 */
	private get typeOptions(): { text: string; value: string }[] {
		return [
			{ text: this.$t('orders.management.parent_card.header.pickup_label'), value: 'pickup' },
			{ text: this.$t('orders.management.parent_card.header.delivery_label'), value: 'delivery' },
			{ text: this.$t('orders.management.parent_card.header.catering_event_label'), value: 'catering-event' }
		];
	}

	/**
	 * Get status options for filter dropdown.
	 *
	 * @return {{ text: string; value: string }[]}
	 */
	private get statusOptions(): { text: string; value: string }[] {
		return [
			{ text: this.$t('orders.management.parent_card.order_card.pending'), value: 'pending' },
			{ text: this.$t('orders.management.parent_card.order_card.in_progress'), value: 'in-progress' },
			{ text: this.$t('orders.management.parent_card.order_card.completed'), value: 'completed' }
		];
	}

	/**
	 * Check if clear filters button should be shown.
	 *
	 * @return {boolean}
	 */
	private get showClearFiltersButton(): boolean {
		return this.tableFilters.selectedTypes.length > 0 ||
			this.tableFilters.selectedStatuses.length > 0;
	}

	/**
	 * Update a specific filter.
	 *
	 * @param {string} filterName
	 * @param {string[]} value
	 * @return {void}
	 */
	private updateFilter(filterName: string, value: string[]): void {
		this.$emit('filter-changed', { filterName, value });
	}
}
